"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileConnectFailureCallback = void 0;
var react_router_dom_1 = require("react-router-dom");
var hooks_1 = require("./hooks");
var ProfileConnectFailureCallback = function (_a) {
    var children = _a.children;
    var _b = (0, hooks_1.useUserIdentityReturnUrlStorage)(), returnUrl = _b[0], clearReturnUrl = _b[2];
    var history = (0, react_router_dom_1.useHistory)();
    var handleRetry = function () {
        clearReturnUrl();
        history.replace(returnUrl);
    };
    return children(handleRetry);
};
exports.ProfileConnectFailureCallback = ProfileConnectFailureCallback;
//# sourceMappingURL=ProfileConnectFailureCallback.js.map